import { Routes } from '@angular/router';
import {Home} from "./home/home";
import {Signin} from "./signin/signin";
import {Nopage} from "./nopage/nopage";
import {Camera} from './camera/camera';
import {ResetPassword} from './reset-password/reset-password';
import {VerifyEmail} from './verify-email/verify-email';
import {Plans} from './plans/plans';
import {Checkout} from './checkout/checkout';
import {Success} from './success/success';
import {Refund} from './refund/refund';
import {Solver} from './solver/solver';

export const routes: Routes = [
    { path: '', component: Home, },

    { path: 'camera', component: Camera },

    { path: 'solver', component: Solver },

    { path: 'signin', component: Signin },

    { path: 'reset-password', component: ResetPassword },

    { path: 'verify-email', component: VerifyEmail },

    { path: 'plans', component: Plans },

    { path: 'checkout', component: Checkout },

    { path: 'checkout/success', component: Success },

    { path: 'refund', component: Refund },

    { path: '**', component: Nopage },

];
